import { createAction, props } from '@ngrx/store';
import { ICashierRevenue } from 'src/app/shared/interfaces/cashier/revenue';

enum CashierActionType {
  LOAD_CASHIER_REVENUE = '[Cashier] load cashier from api',
  LOAD_CASHIER_REVENUE_SUCCESS = '[Cashier] load cashier from api return success',
  LOAD_CASHIER_REVENUE_ERROR = '[Cashier] load cashier from api return error',
  
}
export const loadCashierRevenue = createAction(
    CashierActionType.LOAD_CASHIER_REVENUE
);

export const loadCashierRevenueSuccess = createAction(
    CashierActionType.LOAD_CASHIER_REVENUE_SUCCESS,
  props<{ list: ICashierRevenue[] }>()
);

export const loadCashierRevenueError = createAction(
    CashierActionType.LOAD_CASHIER_REVENUE_ERROR
);